'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5>会员单位</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 -</router-link> <a>会员单位</a>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav">
                  <div class="l_nav_item active">
                     <router-link to="/">
                        理事会名单 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
                  <div class="l_nav_item">
                     <router-link to="/">
                        会员名单 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
                  <div class="l_nav_item">
                     <router-link to="/">
                        入会须知 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
               </div>
               <div class="left_member">
                  <h5 class="titles">会员服务</h5>
                  <div class="login_box">
                     <router-link to="/">登 录</router-link>
                     <router-link to="/">注 册</router-link>
                  </div>
                  <ul>
                     <li>
                        <router-link to="/">
                           <img src="../../assets/images/icon/icon_liwu.png" alt="">
                           会员礼品
                        </router-link>
                     </li>
                     <li>
                        <router-link to="/">
                           <img src="../../assets/images/icon/icon_jidi.png" alt="">
                           星级基地
                        </router-link>
                     </li>
                     <li>
                        <router-link to="/">
                           <img src="../../assets/images/icon/icon_fawu.png" alt="">
                           法务咨询
                        </router-link>
                     </li>
                     <li>
                        <router-link to="/">
                           <img src="../../assets/images/icon/icon_ziliao.png" alt="">
                           资料中心
                        </router-link>
                     </li>
                  </ul>
               </div>
            </div>
            <div class="list_right">
               <div class="right_tongzhi">
                  <div class="right_titlebox">
                     <h5>会员通知</h5>
                     <router-link to="/" class="right_more">MORE <span class="iconfont">&#xe610;</span></router-link>
                  </div>
                  <ul class="right_list">
                     <li v-for="item in 5">
                        <router-link to="/list/1/info/1">
                           <h5 class="l_title">京市内部审计协会举办听党话 跟党走 建功“十四五”主题报告会</h5>
                           <span class="l_date">2022年6月9日</span>
                        </router-link>
                     </li>
                  </ul>
               </div>
               <div class="right_rows">
                  <div class="right_col">
                     <div class="titles">
                        <h5>会员问答</h5>
                        <router-link to="/" class="right_more">MORE <span class="iconfont">&#xe610;</span></router-link>
                     </div>
                     <ul class="col_list">
                        <li v-for="item in 5">
                           <router-link to="/list/1/info/1">
                              <h5 class="l_title">京市内部审计协会举办听党话 跟党走 建功“十四五”主题报告会</h5>
                              <span class="l_date">2022年6月9日</span>
                           </router-link>
                        </li>
                     </ul>
                  </div>
                  <div class="right_col">
                     <div class="titles">
                        <h5>会员风采</h5>
                        <router-link to="/" class="right_more">MORE <span class="iconfont">&#xe610;</span></router-link>
                     </div>
                     <ul class="col_list">
                        <li v-for="item in 5">
                           <router-link to="/list/1/info/1">
                              <h5 class="l_title">京市内部审计协会举办听党话 跟党走 建功“十四五”主题报告会</h5>
                              <span class="l_date">2022年6月9日</span>
                           </router-link>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'list_page',
      components: {},
      data() {
         return {
            typeCode: '', ///分类code
            pageSize: 10,
            pagecount: 100,
         };
      },
      filters: {

      },
      mounted() {

      },
      methods: {

      }
   }

</script>
<style lang="less" scoped>

</style>
